import React from 'react';
import Navbar from '../../components/Navbar2';
import Contact from '../../components/Contact';
import './index.css';

const LifestyleInvestmentsPage = () => {
  return (
    <div className="li-page">
      <Navbar />

      {/* Hero Section */}
      <div className="li-hero">
        <div className="li-hero-overlay" />
        <div className="li-hero-content">
          <p className="li-hero-label">Lifestyle Investments</p>
          <h1 className="li-hero-title">
            Invest in the Way
            <br />
            You Live
          </h1>
          <p className="li-hero-sub">
            Curated opportunities in holiday homes, riverside retreats, managed villas and experiential real estate.
          </p>
        </div>
      </div>

      {/* Intro Section */}
      <div className="li-intro-section">
        <div className="li-intro-inner">
          <p className="li-intro-label">Our Philosophy</p>
          <h2 className="li-intro-title">Where Living Well Meets Smart Investing</h2>
          <p className="li-intro-text">
            Luxe Unbounded presents a curated selection of lifestyle investment opportunities — properties that offer both the joy of ownership and the intelligence of a well-performing asset. Each opportunity is handpicked for location, experience, and long-term value.
          </p>
        </div>
      </div>

      {/* Opportunities Section */}
      <div className="li-opportunities-section">
        {/* Full Width Image */}
        <div className="li-full-image-section">
          <img
            src="https://firebasestorage.googleapis.com/v0/b/phone-auth-d0a8d.appspot.com/o/Luxeunbounded%2FLU%20Amaya%20website%20image.jpg?alt=media&token=f6e0f151-66dd-4a85-8a67-6735140e3910"
            alt="Aamaya Riverside"
            className="li-poster-image"
          />
        </div>

        {/* Details Card */}
        <div className="li-details-card">
          {/* Card Header */}
          <div className="li-card-header">
            <h3 className="li-card-title">Aamaya River Retreat</h3>
            <p className="li-card-location">Agali • Anaikatti, Western Ghats</p>
          </div>

          {/* Key Features */}
          <div className="li-card-features">
            <div className="li-feature-item">
              <div className="li-feature-icon">₹</div>
              <p className="li-feature-text">
                OWN FROM
                <br />
                <strong>₹5.40 LAKHS*</strong>
                <br />
                <span className="li-feature-sub">Per Cent Only</span>
              </p>
            </div>
            <div className="li-feature-item">
              <div className="li-feature-icon">✈</div>
              <p className="li-feature-text">
                JUST
                <br />
                <strong>1HR 25 MINS</strong>
                <br />
                <span className="li-feature-sub">From Coimbatore Airport</span>
              </p>
            </div>
          </div>

          {/* Key Points */}
          <div className="li-card-points">
            <div className="li-point">
              <span className="li-point-icon">✓</span>
              <span className="li-point-text">DTP / RERA Approved Community</span>
            </div>
            <div className="li-point">
              <span className="li-point-icon">✓</span>
              <span className="li-point-text">Fully Gated Community</span>
            </div>
            <div className="li-point">
              <span className="li-point-icon">✓</span>
              <span className="li-point-text">Riverside Living</span>
            </div>
            <div className="li-point">
              <span className="li-point-icon">✓</span>
              <span className="li-point-text">Rental Income Potential</span>
            </div>
          </div>

          {/* Amenities */}
          <div className="li-card-amenities">
            <h4 className="li-amenities-title">Resort-Style Amenities</h4>
            <div className="li-amenities-grid">
              <div className="li-amenity">
                <span className="li-amenity-icon">🏛</span>
                <p>Grand Clubhouse</p>
              </div>
              <div className="li-amenity">
                <span className="li-amenity-icon">🍽</span>
                <p>2 Restaurants</p>
              </div>
              <div className="li-amenity">
                <span className="li-amenity-icon">🌿</span>
                <p>Landscaped Greens</p>
              </div>
              <div className="li-amenity">
                <span className="li-amenity-icon">🚶</span>
                <p>Walking Pathways</p>
              </div>
              <div className="li-amenity">
                <span className="li-amenity-icon">🔒</span>
                <p>24x7 Security</p>
              </div>
            </div>
          </div>

          {/* Investment Benefits */}
          <div className="li-investment-benefits">
            <div className="li-benefit-item">
              <h5 className="li-benefit-title">Build Your Holiday Home</h5>
              <p className="li-benefit-desc">Create your personal retreat in nature's embrace</p>
            </div>
            <div className="li-benefit-item">
              <h5 className="li-benefit-title">Enjoy Weekend Escapes</h5>
              <p className="li-benefit-desc">Experience tranquil riverside living whenever you wish</p>
            </div>
            <div className="li-benefit-item">
              <h5 className="li-benefit-title">Rent When You're Away</h5>
              <p className="li-benefit-desc">Generate consistent rental income through our management</p>
            </div>
            <div className="li-benefit-item">
              <h5 className="li-benefit-title">Earn Attractive Returns</h5>
              <p className="li-benefit-desc">3X ROI potential with long-term appreciation</p>
            </div>
          </div>

          {/* Highlights Section */}
          <div className="li-highlights-section">
            <h4 className="li-highlights-title">Highlights</h4>
            <div className="li-highlights-grid">
              <div className="li-highlight-item">
                <p className="li-highlight-label">
                  Slope Type Plots
                  <br />
                  With Stunning Views
                </p>
              </div>
              <div className="li-highlight-item">
                <p className="li-highlight-label">
                  1.5 KM Perennial
                  <br />
                  River Access
                </p>
              </div>
              <div className="li-highlight-item">
                <p className="li-highlight-label">
                  Premium Clubhouse
                  <br />
                  With World-Class Facilities
                </p>
              </div>
              <div className="li-highlight-item">
                <p className="li-highlight-label">
                  2 Restaurants
                  <br />
                  To Delight Your Weekends
                </p>
              </div>
              <div className="li-highlight-item">
                <p className="li-highlight-label">
                  Landscaped Greens &
                  <br />
                  Wildlife Pathways
                </p>
              </div>
            </div>
          </div>

          {/* CTA Button */}
          <a href="/register" className="li-card-cta">
            Invest in Amaya
          </a>
        </div>
      </div>

      <Contact />
    </div>
  );
};

export default LifestyleInvestmentsPage;
